export default "__VITE_ASSET__DlCRkn6f__"